(() => {
  // app/scripts/common/component/PopupIngredients.js
  if (!window.customElements.get("popup-ingredients")) {
    customElements.define(
      "popup-ingredients",
      class extends HTMLElement {
        constructor() {
          super();
          this.container = this.querySelector("section");
          this.btnClose = this.querySelector(".btn-close");
          this.ingredientTemplate = document.getElementById(
            "popup-ingredients-template"
          );
          this.detailsTemplate = document.getElementById(
            "popup-ingredients-template-details"
          );
          this.headingContainer = this.querySelector(
            ".popup-ingredients__heading"
          );
          this.contentContainer = this.querySelector(
            ".popup-ingredients__content"
          );
          this.scrollbarWidth = this.calculateScrollBarWidth();
        }
        connectedCallback() {
          this.btnClose.addEventListener("click", this.closePopup);
          this.container.addEventListener("click", this.closePopupOutside);
          window.addEventListener("open-popup", this.openPopup);
        }
        disconnectedCallback() {
          this.btnClose.removeEventListener("click", this.closePopup);
          this.container.removeEventListener("click", this.closePopupOutside);
          window.removeEventListener("open-popup", this.openPopup);
        }
        togglePopup(open = true) {
          this.container.classList.toggle("active", open);
          this.container.classList.toggle("opacity-0", !open);
          this.container.classList.toggle("pointer-events-none", !open);
          document.body.classList.toggle("overflow-hidden", open);
          document.body.style.paddingRight = open ? `${this.scrollbarWidth}px` : "0px";
        }
        openPopup = ({ detail }) => {
          const { open, heading, value } = detail;
          this.togglePopup(open);
          this.headingContainer.innerHTML = heading;
          this.renderContent(heading, JSON.parse(value));
        };
        renderContent(type = "Ingredients", data) {
          const fragment = document.createDocumentFragment();
          if (type === "Ingredients") {
            data.forEach(({ quantity, title, sku }) => {
              const productCard = this.ingredientTemplate.content.cloneNode(true).firstElementChild;
              productCard.querySelector(
                ".title"
              ).textContent = `${quantity}g ${title}`;
              productCard.querySelector(".sku").textContent = `Item: ${sku}`;
              fragment.appendChild(productCard);
            });
          } else {
            delete data.form;
            delete data.parentVariantId;
            if (!data.encapsulate) {
              delete data.encapsulate;
              delete data.capsulePrice;
            }
            Object.entries(data).forEach(([key, value]) => {
              const detailLine = this.detailsTemplate.content.cloneNode(true).firstElementChild;
              detailLine.querySelector(".detail-key").textContent = this.transformKey(key);
              detailLine.querySelector(".detail-value").textContent = value;
              fragment.appendChild(detailLine);
            });
          }
          this.contentContainer.innerHTML = "";
          this.contentContainer.appendChild(fragment);
        }
        closePopupOutside = (event) => {
          if (event.target === this.container)
            this.togglePopup(false);
        };
        closePopup = () => this.togglePopup(false);
        calculateScrollBarWidth() {
          const outer = document.createElement("div");
          outer.style.visibility = "hidden";
          outer.style.overflow = "scroll";
          document.body.appendChild(outer);
          const scrollbarWidth = outer.offsetWidth - outer.clientWidth;
          outer.remove();
          return scrollbarWidth;
        }
        transformKey(key) {
          return this.titleMap.get(key) || key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
        }
        titleMap = /* @__PURE__ */ new Map([
          ["type", "Type"],
          ["practitioner_name", "Practitioner Name"],
          ["practitioner_phone", "Practitioner Phone"],
          ["practitioner_notes", "Practitioner Notes"],
          ["patient_name", "Patient Name"],
          ["patient_phone", "Patient Phone"],
          ["patient_instructions", "Patient Instructions"],
          ["pharmacy_instructions", "Pharmacy Instructions"],
          ["ingredients_count", "Ingredients Count"],
          ["ingredients_qty", "Ingredients Qty"],
          ["ingredients_price", "Ingredients Price"],
          ["form", "Form"],
          ["prescription_total", "Prescription Total"],
          ["qty", "Quantity"],
          ["encapsulate", "Encapsulate"],
          ["capsulePrice", "Capsule Price"],
          ["parentVariantId", "Parent Variant Id"]
        ]);
      }
    );
  }
})();
